import styled from 'styled-components';

export const CmsContent = styled.div`
    flex: 1;
`;
export const MarketingImg = styled.div`
    display: flex;
    flex-direction: column;
`;

export const MarketingCard = styled.div`
    flex-direction: row;
    &:last-child {
        margin-right: 0;
    }
    @media screen and (max-width: 600px) {
        margin-right: 0;
        max-width: none;
    }
    @media screen and (max-width: 1200px) {
        flex-direction: column;
    }
`;

export const ImgWrapper = styled.div`
    width: 64px;
    height: 64px;
    margin-right: 26px;
`;
export const LinkWrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: flex-end;
`;
